export function isEven (n) {
  return Math.abs(n % 2) === 0;
}

export function isOdd (n) {
  return Math.abs(n % 2) === 1;
}

export function sumArray (arr) {
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  return sum;
}
